import React, { useState, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import cn from 'classnames';
import useOnClickOutside from "../../../hooks/useOnClickOutside";
// import Button from "../../../components/Button";
// import Checkbox from "../../../components/forms/Checkbox";
import Checkbox from "../../../features/customize-button/components/form/Checkbox";
import {
  selectSecondaryFilter,
  updateSecondaryFilter,
} from "../secondaryFilterSlice";
import { t } from "../../../utilities/translator";
import { scrollToResults } from "../../../utilities/helpers";
import { pushEvent } from "../../../utilities/analytics";
import { PROPERTY_CLASS_FILTER_UPDATE_EVENT, SEC_FILTER_OPEN } from "../../../constants/analyticEvents";
import { clearSelectedHotel } from "../../search/searchSlice";
// import Stars from "../../../components/stars/Stars";
import { filterClearClick, filterSaveClick, setLastChangedFilter } from '../../../appSlice';
import { clearPrefetchDeals } from '../../dealsList/prefetchDealsSlice';

export default function StarsFilter(props) {
  const { side, isOpen, setIsOpen, addFilterToSet } = props;
  const {
    data: { stars },
  } = useSelector(selectSecondaryFilter);
  const [localState, setLocalState] = useState(stars);
  const ref = useRef();
  const dispatch = useDispatch();
  const activeStars = stars.filter(({ active }) => active);
  const name = t('secondaryFilter.property_class');

  const onSaveClick = (event) => {
    setIsOpen(false);
    dispatch(filterSaveClick());
    dispatch(clearPrefetchDeals());
    dispatch(updateSecondaryFilter({ updatedValue: localState, filter: 'stars' }));
    event.stopPropagation();
    dispatch(clearSelectedHotel());
    dispatch(setLastChangedFilter('secondaryFilter'));
    pushEvent(PROPERTY_CLASS_FILTER_UPDATE_EVENT, localState);
    scrollToResults();
  };

  window.external_set_stars = (stars) => {
    addFilterToSet(() => {
      const updatedValue = localState.map((item) => ({ ...item, active: stars.includes(+item.value) }));

      setIsOpen(false);
      dispatch(filterSaveClick());
      dispatch(clearPrefetchDeals());
      dispatch(updateSecondaryFilter({ updatedValue, filter: 'stars' }));
      dispatch(clearSelectedHotel());
      pushEvent(PROPERTY_CLASS_FILTER_UPDATE_EVENT, updatedValue);
      scrollToResults();
    });
  };

  const onClearClick = (event) => {
    setIsOpen(false);
    dispatch(filterClearClick());
    const disable = stars.map((item) => ({ ...item, active: false }));
    setLocalState(disable);
    dispatch(updateSecondaryFilter({ updatedValue: disable, filter: 'stars' }));
    event?.stopPropagation();
    scrollToResults();
    pushEvent(PROPERTY_CLASS_FILTER_UPDATE_EVENT, disable);
  };

  window.external_reset_stars = () => {
    addFilterToSet(() => {
      onClearClick();
    });
  };

  const openFilter = (st) => {
    if (!isOpen) {
      pushEvent(SEC_FILTER_OPEN, { filterName: 'stars' });
    }
    setIsOpen(st);
  };

  useOnClickOutside(ref, () => isOpen && setIsOpen(false));

  const handleCheckbox = (e, index) => {
    setLocalState(localState.map((item, i) => (index === i ? { ...item, active: !item.active } : item)));
    e.stopPropagation();
  };

  useEffect(() => {
    setLocalState(stars);
  }, [stars]);

  /* const renderCheckbox = localState
    .map(({ value, label, active }, i) => (
      <Checkbox
        key={value}
        label={
          <div className="filter-stars">
            <Stars value={value} />
          </div>
        }
        checked={active}
        onChange={(event) => handleCheckbox(event, i)}
      />
    ))
    .reverse(); */
  const renderCheckbox = localState.map((item, i) => (
      <Checkbox
        key={item.value}
        label={`${item.label} ${t('secondaryFilter.stars_plural', { count: item.label })}`}
        checked={item.active}
        onChange={(event) => handleCheckbox(event, i)}
      />
  ));

  let activeName = stars.filter(({ active }) => active).map(({ label }) => label).join(' & ');

  activeName = activeName + ' ' +
    (activeStars.length === 1
      ? activeStars[0].value === 1
        ? t('secondaryFilter.stars_plural', { count: 1 })
        : t('secondaryFilter.stars_plural', { count: 2 })
      : t('secondaryFilter.stars_plural', { count: 2 }));

  const isActiveFilter = stars.filter(({ active }) => active).length > 0;

  return (
    <div className="filter-item filter-item-v2" ref={ref}>
      <p
        className={cn('filter-item__name', {
          'filter-item__name-open': isOpen,
          'filter-item__name-active': isActiveFilter,
        })}
        onClick={() => openFilter(!isOpen)}
        role="menuitem"
        ref={ref}
        tabIndex="0"
      >
        <span>{isActiveFilter ? activeName : name}</span>
        {isActiveFilter ? (
          <i onClick={(event) => onClearClick(event)} className="ri-close-line close" />
        ) : (
          <i className="ri-arrow-down-s-line chevron" />
        )}
      </p>
      {isOpen && (
        <div className={`filter-body filter-body-v2 ${side}`} style={{ minWidth: '250px' }}>
          <div className="flex flex-col-reverse gap-3">{renderCheckbox}</div>
          <div className="filter-footer-v2 flex gap-3">
            <button className="panel-button panel-button__clear py-4 px-6 rounded-full" onClick={onClearClick}>
              {t('buttons.Clear')}
            </button>
            <button className="panel-button panel-button__save py-4 px-6 rounded-full" onClick={onSaveClick}>
              {t('buttons.Save')}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
